import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { Section } from './Shared';
type PlanId = 'completo' | 'base';
const plans: {
  id: PlanId;
  emoji: string;
  name: string;
  desc: string;
  ideal: string;
  oldPrice: string;
  price: string;
  href: string;
  recommended: boolean;
}[] = [{
  id: 'completo',
  emoji: '🟣',
  name: 'KIT TERAPEUTA PRO™ + MARKETING CONSCIENTE',
  desc: 'Sistema completo · Bonos · Upsell estratégico',
  ideal: 'Todo lo anterior + estrategia completa para atraer pacientes ideales',
  oldPrice: '$89.990',
  price: '$27.990 ARS',
  href: 'https://www.lumenakasha.com/cart/kit-completo',
  recommended: true
}, {
  id: 'base',
  emoji: '🔵',
  name: 'KIT TERAPEUTA PRO™',
  desc: 'Sistema completo · 3 bonos incluidos',
  ideal: 'Todo el sistema · Agenda · Fichas · Seguimiento · 3 Bonos',
  oldPrice: '$55.990',
  price: '$19.990 ARS',
  href: 'https://www.lumenakasha.com/cart/kit-base',
  recommended: false
}];
export const Pricing = () => {
  const [selected, setSelected] = useState<PlanId>('completo');
  const selectedPlan = plans.find(p => p.id === selected)!;
  return <Section id="pricing" className="bg-brand-surfaceLight/60 rounded-3xl my-12 border border-brand-gold/20" data-id="element-354">
      <div className="text-center mb-10" data-id="element-355">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-violetDark" data-id="element-356">
          ELEGÍ TU <span className="purple-gradient-text" data-id="element-357">KIT TERAPEUTA</span>
        </h2>
        <p className="text-brand-text/70 mt-3 text-sm md:text-base" data-id="element-358">
          ⏰ El precio de lanzamiento cierra pronto. Después sube $10.000.
        </p>
      </div>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-359">
        {plans.map(plan => {
        const isSelected = selected === plan.id;
        const isRecommended = plan.recommended;
        return <motion.button key={plan.id} type="button" onClick={() => setSelected(plan.id)} whileTap={{
          scale: 0.99
        }} aria-pressed={isSelected} className={`w-full text-left rounded-2xl md:rounded-3xl p-4 md:p-6 border-2 transition-all duration-300 relative ${isRecommended ? 'border-brand-goldDark bg-white animate-glow-pulse shadow-[0_0_34px_rgba(201,169,97,0.45)] md:scale-[1.02] pt-6 md:pt-7 z-[1]' : isSelected ? 'border-brand-goldDark bg-white shadow-[0_0_24px_rgba(201,169,97,0.2)]' : 'border-brand-gold/20 bg-white/70 hover:border-brand-gold/50'}`} data-id="element-360">
              {isRecommended && <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-361">
                  <span className="inline-flex items-center gap-1 gold-gradient-bg text-brand-ink text-[10px] md:text-xs font-extrabold tracking-wider uppercase px-3 py-1 rounded-full shadow-md whitespace-nowrap" data-id="element-362">
                    <Sparkles className="w-3 h-3" data-id="element-363" /> Más elegido · Mejor opción
                  </span>
                </div>}
              <div className="flex items-start gap-3 md:gap-4" data-id="element-364">
                <div className="shrink-0 mt-1" data-id="element-365">
                  <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-brand-goldDark' : 'border-brand-gold/40'}`} data-id="element-366">
                    {isSelected && <motion.div initial={{
                  scale: 0
                }} animate={{
                  scale: 1
                }} className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-brand-goldDark" data-id="element-367" />}
                  </div>
                </div>

                <div className="flex-1 min-w-0" data-id="element-368">
                  {plan.recommended && <div className="flex items-center gap-1.5 mb-1.5 text-brand-goldDark" data-id="element-369">
                      <Sparkles className="w-4 h-4" data-id="element-370" />
                      <span className="text-[10px] md:text-xs font-bold tracking-wide" data-id="element-371">
                        ✨ La mejor opción — el sistema completo + la Mentoría
                      </span>
                    </div>}

                  <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1" data-id="element-372">
                    <div className="min-w-0" data-id="element-373">
                      <h3 className="font-serif font-bold text-sm md:text-lg text-brand-violetDark leading-tight" data-id="element-374">
                        <span className="mr-1.5" data-id="element-375">{plan.emoji}</span>
                        {plan.name}
                      </h3>
                      <p className="text-xs md:text-sm text-brand-text/70 mt-1" data-id="element-376">
                        {plan.desc}
                      </p>
                      <p className="text-[11px] md:text-xs text-brand-violet font-medium mt-1.5" data-id="element-377">
                        {plan.ideal}
                      </p>
                    </div>

                    <div className="text-right shrink-0" data-id="element-378">
                      <p className="text-xs md:text-sm text-brand-text/40 line-through leading-none" data-id="element-379">
                        {plan.oldPrice}
                      </p>
                      <p className={`font-serif font-bold text-lg md:text-2xl leading-tight mt-1 ${isSelected || isRecommended ? 'text-brand-violet' : 'text-brand-text'}`} data-id="element-380">
                        {plan.price}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.button>;
      })}

        <motion.a href={selectedPlan.href} animate={{
        scale: [1, 1.025, 1],
        y: [0, -2, 0]
      }} transition={{
        duration: 2.4,
        ease: 'easeInOut',
        repeat: Infinity
      }} whileHover={{
        scale: 1.04,
        y: -3,
        transition: {
          duration: 0.25
        }
      }} whileTap={{
        scale: 0.98
      }} className="mt-6 w-full inline-flex items-center justify-center px-6 py-4 md:py-5 text-sm md:text-lg font-bold text-white purple-gradient-bg rounded-full animate-glow-pulse relative overflow-hidden cta-shimmer shadow-[0_0_20px_rgba(194,97,79,0.4)]" data-id="element-381">
          <span className="relative z-10" data-id="element-382">
            {selectedPlan.id === 'completo' ? '🏆 → QUIERO TODO EL SISTEMA' : '→ QUIERO MI KIT TERAPEUTA PRO™'}
          </span>
        </motion.a>

        <p className="text-center text-xs md:text-sm text-brand-text/60 pt-2" data-id="element-383">
          🛡️ Garantía 7 días · 📥 Descarga inmediata · 🔒 Pago seguro · 💳
          Mercado Pago
        </p>
      </div>
    </Section>;
};